import React from 'react'
import { useSelector } from "react-redux";
import MyInfoLayer from "./MyInfoLayer";
import Gnb from "./Gnb";

export default function PostEditorHeader () {
  const openMyInfoLayer = useSelector(state => state.gnb.openMyInfoLayer)
  return (
    <>
      <Gnb />
      { openMyInfoLayer && <MyInfoLayer/> }
      <hr className="hide" />
    </>
  )
}
